import styled from 'styled-components'
import { DotWrapper } from 'components/Dot/styles'

interface DeviceProps {
  isMobile: boolean
}

export const ClientTabsWrapper = styled.div<DeviceProps>`
  ${(props: DeviceProps) => props.isMobile ?
  `
    width: 100%;
    margin-top: 36px;
  ` :
  `
    background: white;
    border-radius: 4px;
    padding: 21px 33px;
    display: flex;
    flex-direction: column;
    flex: 1;
  `}
`

export const TabsWrapper = styled.div<DeviceProps>`
  ${ (props: any) => props.isMobile ?
  `
    & .ant-tabs {
      & > .ant-tabs-nav {
        & .ant-tabs-nav-list {
          width: 100%;
          display: flex;
          justify-content: space-between;

          & > .ant-tabs-tab + .ant-tabs-tab {
            margin: 0;
          }
        }
      }
    }
  ` :
  `
    flex: 1;
    overflow: hidden;

    & .ant-tabs {
      height: 100%;
      overflow: hidden;

      .ant-tabs-tab ${DotWrapper} {
        position: absolute;
        right: -12px;
      }

      .ant-tabs-content {
        height: 100%;
        overflow: hidden;
      }
    }
  `}
`
